import { pharmacyApi } from '@/api';
import { PharmacyOrder } from '@/types';
import { useEffect, useState } from 'react';

type OrderPharmacyState =
  | {
      state: 'success';
      data: PharmacyOrder;
    }
  | {
      state: 'loading';
    }
  | {
      state: 'error';
      message: string;
      code?: number;
    };

export function useOrderPharmacy(orderID: string, code?: string | null) {
  const [order, setOrder] = useState<OrderPharmacyState>({
    state: 'loading',
  });

  useEffect(() => {
    pharmacyApi
      .getPharmacyOrder(orderID, code)
      .then(({ data }) => {
        setOrder({
          state: 'success',
          data,
        });
      })
      .catch(err => {
        setOrder({
          state: 'error',
          message: err.message ?? err.data?.error ?? 'Unknown Error',
          code: err.status,
        });
      });
  }, [orderID, code]);

  return {
    order,
    setOrder,
  };
}
